import $http from '@/libs/axios'

class MessagePacksApi {
  static async process(body: any) {
    return (await $http.post('/marketing/message-packs/process', body)).data
  }

  static async getStatisticsOfPacks(body?: any) {
    return (await $http.get('/marketing/message-packs/get-statistics', body)).data
  }
}

export default MessagePacksApi
